import { TEST_ORG_DATA_SOURCE_GUID } from '.'

interface IOrgConfig {
  orgName: string | null
  orgId: number | null
  dataSourceGUID: string | null
}

const allOrgConfigs: IOrgConfig[] = [
  {
    orgName: 'Demo',
    orgId: 211267421,
    dataSourceGUID: '4afd4997-2ac5-3d8f-b10f-3556fd461291',
  },
  {
    orgName: 'Test',
    orgId: 1649890380,
    dataSourceGUID: TEST_ORG_DATA_SOURCE_GUID,
  },
  {
    orgName: 'Staging',
    orgId: 1717673692,
    dataSourceGUID: '8f03f1de-4da4-34a1-be3a-0ba95190d39b',
  },
  {
    orgName: 'Dev',
    orgId: 1765848089,
    dataSourceGUID: '67757573-6d1a-3122-af3b-a31a5f24f204',
  },
  {
    orgName: 'PROD landers',
    orgId: 1667230294,
    dataSourceGUID: '7f0e9103-41db-3a2c-bb7b-e80c02305a7f',
  },
  {
    orgName: 'PROD southerncrossconnect',
    orgId: 1676182735,
    dataSourceGUID: '917012b7-3092-3719-8a0d-ac4665a418a2',
  },
  {
    orgName: 'PROD storyhouse',
    orgId: 654925132,
    dataSourceGUID: 'b24613d1-5e00-3307-9a77-f8d57f506d64',
  },
  {
    orgName: 'PROD mitre10nz',
    orgId: 883684249,
    dataSourceGUID: 'c266d1f9-9a62-3a7e-9646-09617a870c40',
  },
  {
    orgName: 'PROD babybunting',
    orgId: 1560909563,
    dataSourceGUID: '5e8c125c-17d7-3c2c-8070-63be08476ea8',
  },
]

const orgConfigMap = new Map<number, (typeof allOrgConfigs)[0]>()

allOrgConfigs.forEach((orgConfig) => {
  if (orgConfig.orgId) {
    orgConfigMap.set(orgConfig.orgId, orgConfig)
  }
})

export const getOrgConfigById = (orgId: number) => {
  return orgConfigMap.get(orgId)
}

export type { IOrgConfig }
